import { createApp, ref } from 'vue';
import App from './App.vue';
import router from "./router";
import AOS from 'aos';
import 'aos/dist/aos.css';
import i18n from './i18n';
import store from "./state/store";

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import axios from "axios";
import config from './config';
import BootstrapVueNext from 'bootstrap-vue-next';
import vClickOutside from "click-outside-vue3";
import VueApexCharts from "vue3-apexcharts";
import { vMaska } from "maska"

import VueFeather from 'vue-feather';

import '@/assets/scss/config/default/app.scss';
import "leaflet/dist/leaflet.css";
import '@/assets/scss/mermaid.min.css';
import 'bootstrap/dist/js/bootstrap.bundle'

import { install } from "vue3-recaptcha-v2";

// FakeBackend authentication
// import { configureFakeBackend } from './helpers/fake-backend';
// configureFakeBackend();


// Firebase authentication
// import { initFirebaseBackend } from './authUtils';

// const firebaseConfig = {
//     apiKey: process.env.VUE_APP_APIKEY,
//     authDomain: process.env.VUE_APP_AUTHDOMAIN,
//     databaseURL: process.env.VUE_APP_VUE_APP_DATABASEURL,
//     projectId: process.env.VUE_APP_PROJECTId,
//     storageBucket: process.env.VUE_APP_STORAGEBUCKET,
//     messagingSenderId: process.env.VUE_APP_MEASUREMENTID
// };

// initFirebaseBackend(firebaseConfig);

axios.defaults.baseURL = config.baseURLApi

AOS.init({
    easing: 'ease-out-back',
    duration: 1000
});

const app = createApp(App)

app.use(store)
app.use(router)
app.use(VueApexCharts)
app.use(BootstrapVueNext)
app.component(VueFeather.type, VueFeather)
app.directive("maska", vMaska)
app.use(i18n)
app.use(VueSweetalert2)
app.use(vClickOutside)

app.config.globalProperties.$isLoading = ref(false)

app.use(install, {
    sitekey: "6Lc8f-oqAAAAAJjKNHejoh_LUshu-n8TuzL7ZcWA",
    cnDomains: false, // Optional, If you use in China, set this value true
  })

app.mount('#app');